
export const SelectSubmit = (target: HTMLFormElement) => {

  const el = {
    root: target,
    selects: target.querySelectorAll<HTMLSelectElement>('select'),
  }

  const method = {

    init: () => {
      if (!el.root) return
      el.selects.forEach(select => select.addEventListener('change', method.onChange))
    },

    onChange: () => {
      el.root.submit()
    },
  }

  method.init()
}
